import { cn } from '@/lib/utils';

export interface SegmentedOption<T extends string> {
  value: T;
  label: string;
  /** Tailwind classes applied when this option is active (defaults to neutral). */
  activeClass?: string;
}

/**
 * A compact segmented control (iOS-style). Used across agent improvement pages
 * for agent pickers and per-row overrides.
 */
export const Segmented = <T extends string>({
  value,
  onChange,
  options,
  disabled,
  size = 'md',
}: {
  value: T;
  onChange: (v: T) => void;
  options: SegmentedOption<T>[];
  disabled?: boolean;
  size?: 'sm' | 'md';
}) => (
  <div
    className={cn(
      'bg-muted inline-flex rounded-lg p-0.5',
      disabled && 'pointer-events-none opacity-60',
    )}
  >
    {options.map((o) => (
      <button
        key={o.value}
        type="button"
        onClick={() => onChange(o.value)}
        className={cn(
          'rounded-md font-medium transition-colors',
          size === 'sm' ? 'px-3 py-1 text-xs' : 'px-3.5 py-1.5 text-sm',
          value === o.value
            ? (o.activeClass ?? 'bg-background text-foreground shadow-sm')
            : 'text-muted-foreground hover:text-foreground',
        )}
      >
        {o.label}
      </button>
    ))}
  </div>
);
